import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";

class CompletedOrdersStore extends EventEmitter {
    constructor() {
        super();
        this.allOrders=[];
        this.filteredOrders=[];
    }
    getAll() {
        return this.allOrders;
    }
    getSingle(id) {

    }
    getFiltered(){
        return this.filteredOrders;
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_ALL_COMPLETED_ORDERS":
            {
                this.filteredOrders=action.completedOrders;
                this.allOrders=action.completedOrders;
                this.emit("change");
                break
            }
        }
    }

}

const completedOrders = new CompletedOrdersStore;
dispatcher.register(completedOrders.handleActions.bind(completedOrders));

export default completedOrders;



// WEBPACK FOOTER //
// ./src/stores/CompletedOrdersStore.js